import { NavigateFunction } from "react-router-dom";
import { MenuItem } from "../PageNav";
import { TFunction } from "i18next";
import { useState } from "react";
import React from "react";
import { List, ListItemButton, Popover, Tooltip, Typography } from "@mui/material";
import { headerListItemButtonStyles, headerPopoverListStyles, headerPopoverStyles } from "../styles";

interface PopoverMenuProps {
  children: (props: any) => JSX.Element;
  menuItems: MenuItem[];
  t: TFunction;
  navigate: NavigateFunction;
}

export default function PopoverMenu({ children, menuItems, t, navigate }: PopoverMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItemHandler = (menuItem: MenuItem) => {
    if ("path" in menuItem) {
      navigate(menuItem.path);
      handleClose();
    }
  };

  return (
    <React.Fragment>
      <Tooltip title="">
        {children({ onShowPopoverMenu: handleClick })}
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        sx={headerPopoverStyles}
      >
        <List
          sx={headerPopoverListStyles}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          {menuItems.map((item) => (
            <ListItemButton key={item.label} sx={headerListItemButtonStyles} onClick={() => menuItemHandler(item)}>
              <Typography variant="body2">
                {t(item.label)}
              </Typography>
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </React.Fragment>
  );
}
